import { Record, List } from 'immutable';

export default class ReplacementModelPeriodRecord extends Record({
  deviations: new List(),
  isNew: undefined,
  overtime1deviations: undefined,
  overtime1multiplyFactor: undefined,
  overtime1price: undefined,
  overtime1strategy: undefined,
  overtime1articleName: undefined,
  overtime1articleNumber: undefined,
  overtime2deviations: undefined,
  overtime2multiplyFactor: undefined,
  overtime2price: undefined,
  overtime2strategy: undefined,
  overtime2articleName: undefined,
  overtime2articleNumber: undefined,
  price: undefined,
  articleName: undefined,
  articleNumber: undefined,
  // Article-based rows (mode=article_based).
  article: undefined, // article id (for the dropdown selection)
  articleUnit: undefined, // hour/km/count — display label
  articleFactor: undefined, // snapshot of the article factor at booking time

  unitValue: undefined, // payout Value per unit (resource side)
  deriveMode: undefined, // 'factor' | 'flat' (resource side — the invoice factor)
  deriveValue: undefined, // factor multiplier when deriveMode=factor
  deriveFlat: undefined, // flat addend when deriveMode=flat
  customerOverride: undefined, // per-row absolute override (customer side)
  validFrom: undefined,
  workType: undefined,
}) {
}
